var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.pages > 1 || _vm.alwaysVisible)?_c('v-container',{staticClass:"max-width"},[_c('v-pagination',_vm._b({attrs:{"length":_vm.pages},model:{value:(_vm.innerPage),callback:function ($$v) {_vm.innerPage=$$v},expression:"innerPage"}},'v-pagination',_vm.pagerAttrs,false))],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }